module.exports = __webpack_public_path__ + "static/bg-sec10-b236f1b9aef04a476cb7a62a85ee8c60.jpg";